import script from "./ControleVencimentosPlanos.vue?vue&type=script&setup=true&lang=js"
export * from "./ControleVencimentosPlanos.vue?vue&type=script&setup=true&lang=js"

import "./ControleVencimentosPlanos.vue?vue&type=style&index=0&id=d7f2ca8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7f2ca8e"]])

export default __exports__